import {
  getItemByLabelFactory,
  getItemByIdFactory,
  getItemLabelsFactory,
} from './_common'
import type { ISelectItem } from '~/types/models'

export enum OrderStatusIds {
  NOT_STARTED = 1,
  SOME_IN_REVIEW = 2,
  IN_REVIEW = 3,
  SOME_READY_FOR_CONTRACTS = 4,
  READY_FOR_CONTRACTS = 5,
  SOME_PREORDER = 6,
  PREORDER = 7,
  SOME_READY_FOR_SERVICEORDERS = 8,
  READY_FOR_SERVICEORDERS = 9,
  SOME_SERVICEORDERS_IN_PROGRESS = 10,
  SERVICEORDERS_IN_PROGRESS = 11,
  SOME_ACCEPTED = 12,
  ACCEPTED = 13,
  SOME_COMPLETE = 14,
  COMPLETE = 15,
  SOME_ON_HOLD = 16,
  ON_HOLD = 17,
  SOME_CANCELLED = 18,
  CANCELLED = 19,
}

/**
 * The statuses an order is FINISHED in. Everything else is open.
 *
 * Only the whole-order states. 'Some Complete' and 'Some Cancelled' are open:
 * part of the order is still live. On Hold is open too -- it is coming back,
 * as a paused case is (see TERMINAL_CASE_STATUS_IDS).
 *
 * Keyed by ID rather than label: ids are the stable, server-owned identity,
 * while labels are display text (this list spells one 'COMPLETE').
 */
export const TERMINAL_ORDER_STATUS_IDS: readonly OrderStatusIds[] = [
  OrderStatusIds.COMPLETE,
  OrderStatusIds.CANCELLED,
]

/** True for any status that is not terminal — see TERMINAL_ORDER_STATUS_IDS. */
export function isOpenOrderStatus(statusId: number | undefined): boolean {
  return !TERMINAL_ORDER_STATUS_IDS.includes(statusId as OrderStatusIds)
}

export function getOrderStatii(): ISelectItem[] {
  return [
    {
      id: OrderStatusIds.NOT_STARTED,
      label: 'Not Started',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_IN_REVIEW,
      label: 'Some In Review',
      disabled: true,
    },
    {
      id: OrderStatusIds.IN_REVIEW,
      label: 'In Review',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_READY_FOR_CONTRACTS,
      label: 'Some Ready for Contracts',
      disabled: true,
    },
    {
      id: OrderStatusIds.READY_FOR_CONTRACTS,
      label: 'Ready for Contracts',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_PREORDER,
      label: 'Some Preorder',
      disabled: true,
    },
    {
      id: OrderStatusIds.PREORDER,
      label: 'Preorder',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_READY_FOR_SERVICEORDERS,
      label: 'Some Unassigned',
      disabled: true,
    },
    {
      id: OrderStatusIds.READY_FOR_SERVICEORDERS,
      label: 'Unassigned',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_SERVICEORDERS_IN_PROGRESS,
      label: 'Some ServiceOrders in Progress',
      disabled: true,
    },
    {
      id: OrderStatusIds.SERVICEORDERS_IN_PROGRESS,
      label: 'ServiceOrders in Progress',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_ACCEPTED,
      label: 'Some Accepted',
      disabled: true,
    },
    {
      id: OrderStatusIds.ACCEPTED,
      label: 'Accepted',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_COMPLETE,
      label: 'Some Complete',
      disabled: true,
    },
    {
      id: OrderStatusIds.COMPLETE,
      label: 'COMPLETE',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_ON_HOLD,
      label: 'Some On Hold',
      disabled: true,
    },
    {
      id: OrderStatusIds.ON_HOLD,
      label: 'On Hold',
      disabled: true,
    },
    {
      id: OrderStatusIds.SOME_CANCELLED,
      label: 'Some Cancelled',
      disabled: true,
    },
    {
      id: OrderStatusIds.CANCELLED,
      label: 'Cancelled',
      disabled: true,
    },
  ]
}
export const getOrderStatiiLabels = getItemLabelsFactory(getOrderStatii)
export const getOrderStatusByLabel = getItemByLabelFactory(getOrderStatii)
export const getOrderStatusById = getItemByIdFactory(getOrderStatii)
